var hasSymbol = typeof Symbol === 'function' && Symbol.for;
export default hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/ThemeProvider/nested.js
// module id = 911
// module chunks = 2